import { memo, useMemo } from 'react';
import { ScheduleContext } from './contexts.js';
import { jsx } from 'react/jsx-runtime';

/* External */
function LiveInfoProvider(_ref) {
  var _ref$schedule = _ref.schedule,
    _ref$schedule2 = _ref$schedule === void 0 ? {} : _ref$schedule,
    startTime = _ref$schedule2.startTime,
    endTime = _ref$schedule2.endTime,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  var schedule = useMemo(function () {
    return {
      startTime: new Date(startTime),
      endTime: new Date(endTime)
    };
  }, [startTime, endTime]);
  return /*#__PURE__*/jsx(ScheduleContext.Provider, {
    value: schedule,
    children: children
  });
}
var LiveInfoProvider$1 = /*#__PURE__*/memo(LiveInfoProvider);

export { LiveInfoProvider$1 as default };
//# sourceMappingURL=LiveInfoProvider.js.map
